import {css} from "@emotion/react";
import React from 'react';
import {BingMaps} from "../../../AirQualityMonitoring/components/BingMaps";
import {
    columnModalLeft,
    columnModalRight,
    columnModalRightStacked,
    LineMark,
    modalMapHeight,
    modalSubtitle,
    modalTextDescription,
    rowModal,
} from "../../styles";
import {IconBlue} from "../IconBlue";
import {SimpleRow} from "../SimpleRow";
import {BingMapsDetails} from "../../../BingMapsDetails";
import {errorSpan} from "../Modal800CallLogs/styles";


export interface MapRowProps {
    label: React.ReactNode;
    values: MapValues;
    editProps?: MapRowEditProps;
    error: string;
}


const root = css`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr minmax(0, 500px);
  row-gap: 10px;
  column-gap: 10px;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: 
          "content map" 
          "content map" 
          "content map";
  margin-top: 10px;
  margin-bottom: 10px;
`;

const lineMark = css`
  height: 1px;
  margin: 0;
`;
const map = css` grid-area: map; `;


export interface MapValues {
    callerCity: string;
    callerState: string;
    callerZip: string;
    callerAddress: string;
}

export interface MapRowEditProps {
    hideEdit?: boolean;
    values?: MapValues;

    onChange?(name: string, value: string): void;
}

export const MapRow: React.FC<MapRowProps> = ({
    label,
    editProps,
    values,
    error,
}) => {

    const editing = editProps && !editProps.hideEdit;

    if(editing) {

        return (
            <React.Fragment>
                <LineMark />
                <h3 style={{margin:0}}>Address</h3>

                <div style={{marginTop:10,marginBottom:10}}/>

                <div css={rowModal} style={{display:"flex",width:"inherit"}}>

                    <SimpleRow fullWidth={false} variant={"select"} label={"State"} multiRow={true} value={null} editProps={{
                        name: "callerState", value: editProps?.values?.callerState, onChange: editProps?.onChange,
                    }} />
                    <span css={errorSpan}>{error}</span>

                    <SimpleRow fullWidth={false} label={"City"} multiRow={true} value={null} editProps={{
                        name: "callerCity", value: editProps?.values?.callerCity, onChange: editProps?.onChange,
                    }} />

                    <SimpleRow fullWidth={false} label={"Zip Code (optional)"} multiRow={true} value={null} editProps={{
                        name: "callerZip", value: editProps?.values?.callerZip, onChange: editProps?.onChange,
                    }} />

                </div>

                <div style={{marginTop:10,marginBottom:10}}/>

                <SimpleRow fullWidth={true} multiRow={false} label={"Street Name (optional)"} value={null} editProps={{
                    name: "callerAddress", value: editProps?.values?.callerAddress, onChange: editProps?.onChange,
                }} />

                <LineMark />
            </React.Fragment>
        );
    }


    return <div css={root}>
        <LineMark css={lineMark}/>
        <div css={rowModal}>
            <div css={columnModalLeft}>
                <IconBlue/>
                <p css={modalSubtitle}>{label}</p>
            </div>
            <div css={columnModalRight}>
                <div css={columnModalRightStacked}>
                    <div>
                        <p css={modalTextDescription}>
                            {values.callerAddress}
                        </p>
                    </div>
                    <div>
                        <p css={modalTextDescription}>
                            {values.callerCity}
                        </p>
                    </div>
                    <div>
                        <p css={modalTextDescription}>
                           {values.callerState + " " + values.callerZip}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <LineMark css={lineMark}/>
        <div css={[columnModalRight, map]}>
            <div css={modalMapHeight}>
                <BingMapsDetails city={values.callerCity} state={values.callerState} postalCode={values.callerZip} address={values.callerAddress}/>
            </div>
        </div>
    </div>
};